import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import { InputEl } from "common/components/input";
import { InputType } from "common/components/input/types";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { SelectEl } from "common/components/select";
import { InputLabelEl } from "common/components/input/label";
import { formatText } from "common/util/format-text";
import { FeedbackForFeature, Sentiment } from "./types";
function SentimentButton(props) {
  const sentiment = props.sentiment;
  const cmp = props.cmp;
  return /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".sentiment-button",
    attrs: {
      theme: ButtonTheme.Select,
      pressed: cmp.state.sentiment === sentiment,
      icon: sentiment === Sentiment.Positive ? `thumbs-up` : `thumbs-down`
    },
    on: { click: () => cmp.update({ sentiment }) }
  }, sentiment === Sentiment.Positive ? cmp.positiveLabel : cmp.negativeLabel);
}
export function template() {
  const FeedbackPrompt = () => {
    const isSubmitDisabled = this.state.saving || !this.state.feedback && !this.state.sentiment;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".content"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".title"
    }, this.title), this.state.submitErrorMsg && /* @__PURE__ */ jsx(BannerEl, {
      attrs: {
        theme: BannerTheme.Error,
        type: BannerType.Embedded,
        "body-text": `Failed to submit feedback: ${this.state.submitErrorMsg}`
      }
    }), this.attr(`feature`) !== FeedbackForFeature.General && /* @__PURE__ */ jsx("div", {
      sel: ".sentiment"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".sentiment-prompt"
    }, this.sentimentHeading), /* @__PURE__ */ jsx("div", {
      sel: ".sentiment-controls"
    }, /* @__PURE__ */ jsx(SentimentButton, {
      sentiment: Sentiment.Positive,
      cmp: this
    }), /* @__PURE__ */ jsx(SentimentButton, {
      sentiment: Sentiment.Negative,
      cmp: this
    }))), this.canDelegateFeedback() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".customer-email-input"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        type: InputType.Text,
        label: this.t(`help.feedback.email-prompt`),
        placeholder: this.t(`help.feedback.email-placeholder`)
      },
      props: { value: this.state.customerEmail },
      on: { input: this.handleCustomerEmailInput }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".opportunity-id-input"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        type: InputType.Text,
        label: this.t(`help.feedback.sfdc-prompt`),
        placeholder: this.t(`help.feedback.sfdc-placeholder`)
      },
      props: { value: this.state.sfdcOpportunityId },
      on: { input: this.handleSfdcOpportunityId }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".feedback-type-select"
    }, /* @__PURE__ */ jsx(InputLabelEl, {
      attrs: {
        label: this.t(`help.feedback.type-prompt`)
      }
    }), /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        "menu-width": 300
      },
      props: {
        sections: this.getFeedbackTypeSections()
      },
      on: {
        change: (ev) => this.handleSelectFeedbackType(ev.detail.item)
      }
    }))) : null, /* @__PURE__ */ jsx("div", {
      sel: ".feedback-input"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        type: InputType.TextArea,
        placeholder: this.placeholder
      },
      props: { value: this.state.feedback },
      on: { input: this.handleFeedbackInput }
    })), /* @__PURE__ */ jsx("div", null, formatText(this.t(`help.feedback.schedule-pm-call`)))), /* @__PURE__ */ jsx("div", {
      sel: ".actions"
    }, /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".cancel-btn",
      attrs: {
        theme: ButtonTheme.Tertiary,
        role: `button`
      },
      on: { click: () => this.closeModal(false) }
    }, this.t(`help.feedback.cancel`)), /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".submit-btn",
      attrs: {
        theme: ButtonTheme.Primary,
        disabled: isSubmitDisabled,
        icon: this.state.saving ? `spinner` : ``,
        style: isSubmitDisabled ? `pointer-events: none;` : ``
      },
      on: { click: this.submitFeedback }
    }, this.state.saving ? this.t(`help.feedback.submit-pending`) : this.submitButtonText)));
  };
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: ".feedback-modal",
    attrs: { open: true, closeable: true, "grow-to-content": true },
    on: { change: this.handleModalChange }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".body"
  }, /* @__PURE__ */ jsx(FeedbackPrompt, null)));
}
